import axios from 'axios'
import API from '@/services/API/api'
import INITIAL_SUMMARIES from '@/services/API/mock-data/PaymentSummaries/mockInitialSummaries'
import INITIAL_SUMM_ERROR from '@/services/API/mock-data/PaymentSummaries/mockErrorInitialSummaries'
import SUMMARIES_GENERATED from '@/services/API/mock-data/PaymentSummaries/mockSummariesGenerated'

const fetchInitialResume = async function(posCashDeskId) {
    //console.log(INITIAL_SUMMARIES,'im here in service')
    //return (posCashDeskId ==1 ) ? INITIAL_SUMMARIES : INITIAL_SUMM_ERROR
    try {
        console.log(API.POS_DAILY_CASH_INITIAL_RESUME)
        //console.log(posCashDeskId)
        let response = await axios.get(API.POS_DAILY_CASH_INITIAL_RESUME, {
            params: { pos_cash_desk_id: posCashDeskId },
        })
        console.log('RESPONSE:')
        console.log(response.data)
        return response.data
    } catch (error) {
        console.log('ERROR:')
        console.log(error)
        return error.response
    }
}

const getPaymentSummaries = async function(cashDeskId, authCodeSupervisor) {
    try {
        let response = await axios.get(API.POS_DAILY_CASH_COMPLETE_RESUME, {
            params: {
                pos_cash_desk_id: cashDeskId,
                auth_code_supervisor: authCodeSupervisor,
            },
        })
        return response.data
    } catch (error) {
        return error.response
    }
}

export default {
    getPaymentSummaries,
    fetchInitialResume,
}
